import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  NumberField,
  Pagination,
  TopToolbar,
  SearchInput,
  SelectInput,
  BooleanInput,
  TextInput,
} from "react-admin";
import { PropertyStatusChip } from "./components/PropertyStatusChip";
import { PropertyVisibilityActions } from "./components/PropertyVisibilityActions";
import { PropertyShow } from "./components/PropertyShow";

// Custom List Actions - Empty to remove default export button
const ListActions = () => <TopToolbar />;

// Property List Component
export const PropertyList = () => (
  <List
    filters={[
      <SearchInput
        key="search"
        source="search"
        placeholder="Search by name or HID"
        alwaysOn
      />,
      <TextInput
        key="regionId"
        source="regionId"
        label="Region ID"
        placeholder="Enter region ID"
      />,
      <SelectInput
        key="kind"
        source="kind"
        choices={[
          { id: "hotel", name: "Hotel" },
          { id: "apartment", name: "Apartment" },
          { id: "villa", name: "Villa" },
          { id: "hostel", name: "Hostel" },
          { id: "resort", name: "Resort" },
          { id: "guesthouse", name: "Guesthouse" },
          { id: "bed_and_breakfast", name: "Bed & Breakfast" },
          { id: "motel", name: "Motel" },
          { id: "inn", name: "Inn" },
          { id: "campsite", name: "Campsite" },
        ]}
        label="Property Type"
      />,
      <SelectInput
        key="starRating"
        source="starRating"
        choices={[
          { id: "0", name: "No Rating" },
          { id: "1", name: "1 Star" },
          { id: "2", name: "2 Stars" },
          { id: "3", name: "3 Stars" },
          { id: "4", name: "4 Stars" },
          { id: "5", name: "5 Stars" },
        ]}
        label="Star Rating"
      />,
      <BooleanInput
        key="includeDeleted"
        source="includeDeleted"
        label="Include Deleted"
      />,
      <BooleanInput
        key="includeClosed"
        source="includeClosed"
        label="Include Closed"
      />,
    ]}
    title="Properties"
    perPage={20}
    filterDefaultValues={{}}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100]} />}
    actions={<ListActions />}
  >
    <Datagrid rowClick="show">
      <TextField source="hid" label="HID" />
      <TextField source="name" />
      <TextField source="address" />
      <TextField source="regionName" label="Region" />
      <TextField source="regionType" label="Region Type" />
      <NumberField source="starRating" label="Stars" />
      <TextField source="kind" />
      <PropertyStatusChip />
      <PropertyVisibilityActions />
      <ShowButton />
    </Datagrid>
  </List>
);

// Export the PropertyShow component from the components directory
export { PropertyShow };

// Property Edit Component (Read-only)
export const PropertyEdit = () => <PropertyShow />;

// Property Create Component (Not supported by API)
export const PropertyCreate = () => (
  <div>
    <h2>Property Creation Not Supported</h2>
    <p>Properties cannot be created through the admin interface.</p>
  </div>
);
